import { Box, Button, TextField } from '@mui/material'
import React from 'react'

export default function AddTemplate({
    title,
    message,
    media,
    setTitle,
    setMessage,
    setMedia,
    handleSubmit
}) {
  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 5, mx: 'auto', width: '70%' }}>
        <TextField
        onChange={e => setTitle(e.target.value)}
        value={title}
        color="secondary"
        margin="normal"
        required
        fullWidth
        label="Title"
        autoFocus
        error={title === ""}
        helperText={title === "" ? "Empty!" : " "}
        />
        <TextField
        onChange={e => setMessage(e.target.value)}
        value={message}
        color="secondary"
        margin="normal"
        required
        fullWidth
        label="Message (Hit (return) to break line)"
        multiline
        rows={3}
        maxRows={15}
        error={message === ""}
        helperText={message === "" ? "Empty!" : " "}
        />
        <TextField
        onChange={e => setMedia(e.target.value)}
        value={media}
        color="secondary"
        margin="normal"
        fullWidth
        label="Media (https://googleurl.com/image)"
        />
        <Button
        type="submit"
        fullWidth
        variant="contained"
        color="secondary"
        sx={{ mt: 3, mb: 2 }}
        >
        Add Template
        </Button>
    </Box>
  )
}
